/** Public store listings for the H-Plate app. */
export const APP_STORE_URL = "https://apps.apple.com/app/id6822191513";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.hplate.app";
